import { OnDestroy, Directive } from '@angular/core';
import { AppState, AppStore } from '@app/app.store';
import { Store } from '@app/shared/store/store';
import { Subject } from 'rxjs';
import { delay, takeUntil } from 'rxjs/operators';

@Directive()
export abstract class StoreContainer<T, U extends Store<T>> implements OnDestroy {
  protected destroyed = new Subject();
  appState: AppState;
  state: T;

  constructor(public store: U, public appStore: AppStore, subscribeImmediately = true) {
    this.appStore.state$
      .pipe(
        delay(0),
        takeUntil(this.destroyed)
      )
      .subscribe(state => {
        this.appState = state;
      });
    if (subscribeImmediately) {
      this.store.state$
        .pipe(
          delay(0),
          takeUntil(this.destroyed)
        )
        .subscribe(storeState => {
          this.state = storeState;
        });
    }
  }

  ngOnDestroy() {
    this.destroyed.next();
  }
}
